import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";

const Title = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
`
const InputLabel = styled.label`
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
    color: #555;
`
const InputData = styled.input`
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    &:focus {
        border-color: #007bff;
        outline: none;
        box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
`
const BotoesWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
`
const BotaoAplicar = styled.button`
    padding: 8px 16px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
        background-color: #0056b3;
    }
`

const ModalFilters = ({ fecharModal, filtros, setFiltros, aplicarFiltros }) => {

    const handleChange = ( e ) => {

        const { name, value } = e.target;

        setFiltros(( prev ) => ({
            ...prev,
            [ name ]: value
        }))

    }

    return (
        <>
            <Overlay state={ true } >
                <Modal size="md" header close={ fecharModal } >
                    <Title>Filtros</Title>
                    <div>
                        <InputLabel htmlFor="data-inicial">Data Inicial:</InputLabel>
                        <InputData type="date" id="data-inicial" name="dataInicio" value={filtros.dataInicio} onChange={handleChange} />
                    </div>
                    <div>
                        <InputLabel htmlFor="data-final">Data Final:</InputLabel>
                        <InputData type="date" id="data-final" name="dataFim" value={filtros.dataFim} onChange={handleChange} />
                    </div>
                    <BotoesWrapper>
                        <BotaoAplicar onClick={aplicarFiltros}>Aplicar Filtros</BotaoAplicar>
                    </BotoesWrapper>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalFilters;